import AddingSSHKeysAtomic from "../../../../src/courses/partials/ssh/adding-ssh-keys-atomic.mdx";
import * as React from 'react';
export default {
  AddingSSHKeysAtomic,
  React
};